export enum AssetWorkflow {
    create = "create",
    edit = "edit",
}

export enum AssetStep {
    basicData = 1,
    organisationalAttributes,
    technicalData,
    features,
    location,
    finance,
    summary
}
